import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const CUSTOM_KD_API_URL = new InjectionToken<Observable<string>>('customKdApiUrl');
